import { manifestApi } from '../../api/manifestApi.js'

import { addNotification } from './notificationActions'

import { schemaManifestSignal, schemaManifestErrorSignal, schemaManifestLoadedSignal } from '../signals/schemaManifestSignals.js'

export const fetchSchemaManifest = async () => {
    schemaManifestLoadedSignal.value = false
    schemaManifestSignal.value = null
    return await manifestApi.fetchSchemaManifest().then(
        (data) => {
            schemaManifestSignal.value = data
            schemaManifestLoadedSignal.value = true
            return data
        }
    ).catch(
        (err) => {
            schemaManifestErrorSignal.value = err
            console.log(err)
            addNotification(`Unable to load schema manifest: ${err}`)
        }
    )
}